import { h, Component } from 'preact';
import dlv from 'dlv';

import style from './style';
import pageStyles from '../../../pageStyles';

import SimpleGridCluster from '../../../../clusters/simple-grid-cluster';
import CategoryCluster from '../../../../clusters/category-cluster';
import PromoCluster from '../../../../clusters/promo-cluster';
import SupportClusterP23 from '../../../../clusters/support-cluster-p23';
import SpotlightCluster from '../../../../clusters/spotlight-cluster';
import TextCluster from '../../../../clusters/text-cluster';
import { OccasionBanner } from '../../../../pieces/occasion-banner';
import { TopBorder } from '../../../../pieces/top-border';
import { SadlibAd } from '../../../../pieces/sadlib-ad';
import { TaboolaJs } from '../../../../pieces/taboola-js';
import { InsticatorJs } from '../../../../pieces/insticator-js';
import { GamePromotion } from '../../../../pieces/game-promotion';
import { Header, Footer } from '../../../shared/desktop';
import { getCommonProps } from '../../../../../lib/page';
import { getBucket } from '../../../../../lib/abtest';
import { WeatherWidget } from '@cube/weather-widget';
import CardHeader from '../../../../pieces/card-header';

import { DccWidget } from '@cube/dcc-widget-v2';
import { StocksWidget } from '@cube/finance-components';
import { Column, Row, Section, ContainerFluid } from '@cube/layout';
import Notifications from '@cube/notifications';
import { containerSize, RenderOnVisible  } from '@cube/blocks';

const HERO_BREAKPOINT=1140;

@containerSize({ height: false, target: 'self' })
export default class Desktop extends Component {
	render ({ pageConfig, width, ...props }) {
		return (
			<ContainerFluid class={pageStyles.fluidPageNoPadding}>
				<Header
					pageConfig={pageConfig}
					adId="sc_home_header_banner"
					{...props}
				/>
				<Section containerClass={pageStyles.defaultPageWidth}>
					<OccasionBanner />
					<SadlibAd id="sc_home_bodymasthead_banner" type="desktopBanner" />
					{dlv(pageConfig, 'clusters.promo.aboveDCC') &&
						<Row>
							<Column>
								<PromoCluster
									{...dlv(pageConfig, 'clusters.promo')}
									{...getCommonProps(props)}
								/>
							</Column>
						</Row>
					}
				</Section>
				<Section containerClass={pageStyles.defaultPageWidth}>
					<Notifications
						alertClass={style.notification}
						{...getCommonProps(props)}
					/>
					<div class={style.heroRow}>
						<div class={style.heroLeftColumn}>
							<CardHeader title="Top Stories" />
							<DccWidget
								cardSize={width > HERO_BREAKPOINT ? 'medium-16:10' : 'medium-16:9'}
								variant={getBucket(pageConfig.dccVariantCookie)}
								{...dlv(pageConfig, 'clusters.dcc')}
								{...getCommonProps(props)}
							/>
							<TaboolaJs
								{...dlv(pageConfig, 'taboola.subDcc')}
								qeId="sc-home-subdcc"
								class={style.taboolaSubDcc}
							/>
						</div>
						{ width > HERO_BREAKPOINT &&
							<div class={style.heroMiddleColumn}>
								<SpotlightCluster
									{...dlv(pageConfig, 'clusters.spotlight')}
									qeId="sc-home-spotlight"
									{...getCommonProps(props)}
								/>
							</div>
						}
						<div key="heroRightColumn" class={style.heroRightColumn}>
							<div class={style.miniWeather}>
								<WeatherWidget
									displayMode="mini"
									{...getCommonProps(props)}
								/>
							</div>
							<div class={style.defaultWidthAd}>
								<SadlibAd id="sc_home_hero_sidebar" type="desktopRail" />
							</div>
							<div class={style.gameWrapper}>
								<GamePromotion />
							</div>
							<TextCluster
								{...dlv(pageConfig, 'clusters.recent')}
								qeId="sc-home-recent"
								customizeKey="recentStories"
								{...getCommonProps(props)}
							/>
						</div>
					</div>
					{ width <= HERO_BREAKPOINT &&
						<SimpleGridCluster
							{...dlv(pageConfig, 'clusters.spotlight')}
							qeId="sc-home-spotlight"
							imageRole="w=256,h=144"
							rowCount={1}
							columnCount={4}
							clusterClass={style.spotlightRow}
							{...getCommonProps(props)}
						/>
					}
				</Section>
				<Section containerClass={pageStyles.defaultPageWidth}>
					{dlv(pageConfig, 'clusters.promo.belowDCC') &&
						<Row>
							<Column class={style.verticalMargin}>
								<PromoCluster
									{...dlv(pageConfig, 'clusters.promo')}
									{...getCommonProps(props)}
								/>
							</Column>
						</Row>
					}
					<Row>
						<Column>
							<SupportClusterP23
								{...dlv(pageConfig, 'clusters.support')}
								qeId="sc-home-alerts"
								{...getCommonProps(props)}
							/>
						</Column>
					</Row>
				</Section>
				<Section containerClass={pageStyles.defaultPageWidth}>
					<Row>
						<Column class={pageStyles.fixedLeftColumn}>
							<TopBorder />
							<CategoryCluster
								{...dlv(pageConfig, 'clusters.latestEntertainment')}
								qeId="sc-home-entertainment"
								{...getCommonProps(props)}
							/>
						</Column>
						<Column class={pageStyles.fixedRightColumn}>
							<TopBorder />
							{dlv(pageConfig, 'clusters.insticator.id') ?
								<InsticatorJs
									{...dlv(pageConfig, 'clusters.insticator')}
									requireComplete
								/>
								:
								<SimpleGridCluster
									{...dlv(pageConfig, 'clusters.latestTrailers')}
									qeId="sc-home-trailers"
									{...getCommonProps(props)}
								/>
							}
						</Column>
					</Row>
				</Section>
				<Section rowClass={style.recRow} containerClass={pageStyles.defaultPageWidth}>
					<TopBorder />
					<SimpleGridCluster
						{...dlv(pageConfig, 'clusters.latestHealth')}
						qeId="sc-home-latestHealth"
						{...getCommonProps(props)}
					/>
				</Section>
				<Section containerClass={pageStyles.defaultPageWidth}>
					<Row>
						<Column class={pageStyles.fixedLeftColumn}>
							<TopBorder />
							<CategoryCluster
								{...dlv(pageConfig, 'clusters.latestNews')}
								qeId="sc-home-news"
								{...getCommonProps(props)}
							/>
						</Column>
						<Column class={pageStyles.fixedRightColumn}>
							<TopBorder />
							<RenderOnVisible>
								<WeatherWidget
									{...getCommonProps(props)}
								/>
							</RenderOnVisible>
							<TaboolaJs class={style.youMayAlsoLike} {...dlv(pageConfig, 'taboola.rightRailBelowWeather')} qeId="sc-home-youmayalsolike" />
						</Column>
					</Row>
					<Row>
						<Column class={pageStyles.fixedLeftColumn}>
							<TopBorder />
							<CategoryCluster
								{...dlv(pageConfig, 'clusters.latestSports')}
								qeId="sc-home-sports"
								{...getCommonProps(props)}
							/>
						</Column>
						<Column class={pageStyles.fixedRightColumn}>
							<TopBorder />
							<SimpleGridCluster
								{...dlv(pageConfig, 'clusters.sportsVideos')}
								qeId="sc-home-sportsvideos"
								{...getCommonProps(props)}
							/>
						</Column>
					</Row>
					<Row>
						<Column class={pageStyles.fixedLeftColumn}>
							<TopBorder />
							<CategoryCluster
								{...dlv(pageConfig, 'clusters.latestBusiness')}
								qeId="sc-home-business"
								{...getCommonProps(props)}
							/>
						</Column>
						<Column class={pageStyles.fixedRightColumn}>
							<TopBorder />
							<RenderOnVisible>
								<StocksWidget {...getCommonProps(props)} />
							</RenderOnVisible>
						</Column>
					</Row>
					<TaboolaJs {...dlv(pageConfig, 'taboola.bottomPage')} qeId="sc-home-taboolabottompage" />
				</Section>
				<SadlibAd id="adhesion" />
				<Footer
					pageConfig={pageConfig}
					{...getCommonProps(props)}
				/>
			</ContainerFluid>
		);
	}
}
